import React, { Fragment } from 'react';
import MuiCard from '@material-ui/core/Card';
import MuiCardContent from '@material-ui/core/CardContent';
import MuiCardHeader from '@material-ui/core/CardHeader';
import MuiDivider from '@material-ui/core/Divider';
import MuiFade from '@material-ui/core/Fade';
import { WarboxCardProps } from './types';

export const Card = ({
    intent = 'container',
    children,
    in: inProp = true,
    ...props
}: WarboxCardProps) => {
    const Header = (
        <Fragment>
            <MuiCardHeader title={props.title} />
            <MuiDivider />
        </Fragment>
    );

    return (
        <MuiFade in={inProp} timeout={600}>
            <MuiCard {...props} elevation={0}>
                {intent === 'section' && Header}
                <MuiCardContent>{children}</MuiCardContent>
            </MuiCard>
        </MuiFade>
    );
};
